/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    tabsContainer: {
      padding: '0 15px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    tabTitlesRow: {
      display: 'flex',
      borderBottom: '0.5px solid grey',
    },
    tabTitle: {
      fontSize: 16,
      fontWeight: 550,
      width: '50%',
      height: 50,
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      color: 'grey',
      cursor: 'pointer',
      borderBottom: '3px solid transparent',
      transition: 'color 0.3s, border-bottom 0.3s',
      '&.active': {
        color: 'white',
        borderBottom: '3px solid white',
      },
    },
    tabContent: {
      flex: 1,
      overflowY: 'auto',
      padding: '15px 0',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
